import store from '../../store';

export const getUsuario = () => (
    store.getState().session.usuario
);

export const getCpf = () => (
    store.getState().session.usuario.cpf
);

export const getNitPrincipal = () => (
    store.getState().session.pessoaCnis.nitPrevalente
);

export const getElosNit = () => {
    let pessoa = store.getState().session.pessoaCnis;
    if(pessoa !== "erro" && pessoa !== "not found" && pessoa !== "" && pessoa) {
        return store.getState().session.pessoaCnis.elos;
    } 
    return null;
};

export const isLoggedIn = () => (
    store.getState().session.usuarioLogado
);


//-----------------------

export const someCheckBeneficioAtivo = (beneficio) =>(
    beneficio.situacao === "ATIVO"
)